const userColumns = [
  {
    name: "id",
    label: "ID",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "name",
    label: "Nombre",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "last_name",
    label: "Apellido",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "email",
    label: "Correo",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "phone_number",
    label: "Teléfono",
    options: {
      filter: true,
      sort: true,
    },
  },
];

export default userColumns;